(function () {
  'use strict';

  var optimizedImages = new WeakSet();
  var prefetchedUrls = new Set();
  var prefetchLimit = 4;
  var idleCallback = window.requestIdleCallback || function (callback) {
    return window.setTimeout(callback, 1);
  };

  /**
   * Complète les attributs natifs des images différées sans modifier leur URL.
   * Le navigateur reste responsable du chargement et du choix de la source.
   */
  function optimizeImage(image) {
    if (!(image instanceof HTMLImageElement) || optimizedImages.has(image)) return;

    optimizedImages.add(image);

    if (!image.hasAttribute('decoding')) {
      image.decoding = 'async';
    }

    if (image.loading === 'lazy' && !image.hasAttribute('fetchpriority')) {
      image.setAttribute('fetchpriority', 'low');
    }
  }

  /**
   * Traite le document initial et les fragments ajoutés par l’éditeur Shopify,
   * la recherche prédictive, les recommandations ou le panier dynamique.
   */
  function optimizeImages(root) {
    var scope = root || document;

    if (scope instanceof HTMLImageElement) {
      optimizeImage(scope);
      return;
    }

    if (!scope.querySelectorAll) return;

    var images = scope.querySelectorAll('img[loading="lazy"]');
    for (var index = 0; index < images.length; index += 1) {
      optimizeImage(images[index]);
    }
  }

  /**
   * Regroupe les mutations avant traitement afin d’éviter de rescanner toute
   * la page après chaque changement du DOM.
   */
  function observeDynamicContent() {
    if (!('MutationObserver' in window) || !document.body) return;

    var pendingNodes = [];
    var updateScheduled = false;

    function flushPendingNodes() {
      updateScheduled = false;

      for (var index = 0; index < pendingNodes.length; index += 1) {
        optimizeImages(pendingNodes[index]);
      }

      pendingNodes = [];
    }

    var observer = new MutationObserver(function (mutations) {
      for (var mutationIndex = 0; mutationIndex < mutations.length; mutationIndex += 1) {
        var addedNodes = mutations[mutationIndex].addedNodes;

        for (var nodeIndex = 0; nodeIndex < addedNodes.length; nodeIndex += 1) {
          if (addedNodes[nodeIndex].nodeType === Node.ELEMENT_NODE) {
            pendingNodes.push(addedNodes[nodeIndex]);
          }
        }
      }

      if (pendingNodes.length && !updateScheduled) {
        updateScheduled = true;
        idleCallback(flushPendingNodes, { timeout: 300 });
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  /**
   * Met en pause les médias automatiques lorsque le visiteur demande moins
   * d’animations. Les contrôles manuels restent utilisables.
   */
  function setupReducedMotion() {
    if (!window.matchMedia) return;

    var motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');

    function applyMotionPreference(event) {
      var reduceMotion = event.matches;
      document.documentElement.classList.toggle('up-reduced-motion', reduceMotion);

      if (!reduceMotion) return;

      var autoplayVideos = document.querySelectorAll('video[autoplay]');
      for (var index = 0; index < autoplayVideos.length; index += 1) {
        autoplayVideos[index].pause();
      }
    }

    applyMotionPreference(motionPreference);

    if (motionPreference.addEventListener) {
      motionPreference.addEventListener('change', applyMotionPreference);
    } else if (motionPreference.addListener) {
      motionPreference.addListener(applyMotionPreference);
    }
  }

  /**
   * Précharge au maximum quatre pages produit après une intention explicite
   * (survol ou focus), jamais sur une connexion limitée.
   */
  function setupProductPrefetch() {
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

    if (connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || ''))) {
      return;
    }

    function prefetchFromEvent(event) {
      if (prefetchedUrls.size >= prefetchLimit) return;

      var link = event.target.closest && event.target.closest('a[href]');
      if (!link) return;

      var url;
      try {
        url = new URL(link.href, window.location.href);
      } catch (error) {
        return;
      }

      if (url.origin !== window.location.origin || url.pathname.indexOf('/products/') === -1) return;
      if (prefetchedUrls.has(url.href) || url.href === window.location.href) return;

      prefetchedUrls.add(url.href);

      var prefetchLink = document.createElement('link');
      prefetchLink.rel = 'prefetch';
      prefetchLink.href = url.href;
      prefetchLink.as = 'document';
      document.head.appendChild(prefetchLink);
    }

    document.addEventListener('pointerover', prefetchFromEvent, { passive: true });
    document.addEventListener('focusin', prefetchFromEvent);
  }

  function initializeThemeUtilities() {
    idleCallback(function () {
      optimizeImages(document);
      observeDynamicContent();
      setupReducedMotion();
      setupProductPrefetch();
    }, { timeout: 500 });

    document.addEventListener('shopify:section:load', function (event) {
      optimizeImages(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeThemeUtilities, { once: true });
  } else {
    initializeThemeUtilities();
  }
})();